import TimezoneSlect from './TimezoneSelect';

export default TimezoneSlect;
